var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_1156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38747 1.72353C8.13757 1.47356 7.79862 1.33308 7.44516 1.33301H2.66565C2.31216 1.33301 1.97315 1.47343 1.7232 1.72338C1.47325 1.97334 1.33282 2.31235 1.33282 2.66583V7.44534C1.3329 7.7988 1.47337 8.13776 1.72334 8.38765L7.5238 14.1881C7.82669 14.4891 8.23636 14.658 8.66336 14.658C9.09037 14.658 9.50003 14.4891 9.80293 14.1881L14.1879 9.80311C14.4889 9.50022 14.6578 9.09055 14.6578 8.66355C14.6578 8.23654 14.4889 7.82687 14.1879 7.52398L8.38747 1.72353Z",
    stroke: "#2B7FFF",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99812 5.33145C5.18215 5.33145 5.33133 5.18227 5.33133 4.99825C5.33133 4.81422 5.18215 4.66504 4.99812 4.66504C4.8141 4.66504 4.66492 4.81422 4.66492 4.99825C4.66492 5.18227 4.8141 5.33145 4.99812 5.33145Z",
    fill: "#2B7FFF",
    stroke: "#2B7FFF",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_1156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9939,
    height: 15.9939,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.79a2efbef4f7e0c00253eebb1d3c8033.svg";
export { ForwardRef as ReactComponent };